module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-clock-4171524dde63ae962b44c5137da7d3ab.png";